// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "LogoMakerGuestLazyComponent" + "." + "e45c77960b1ef996e8f8" + ".css";
};